import React, { useEffect, useState, useRef } from 'react';
import { Container, Row, Col, Form, Card, Spinner } from 'react-bootstrap';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faCreditCard, faEnvelope, faUser, faPhone, faHome, faMoneyBillWave } from '@fortawesome/free-solid-svg-icons';
import './DonationForm.css'; // Assuming you have a CSS file for custom styles
import { CampaignService, DonationService, SubscriptionService, PaymentMethodService } from '../../Services/Axios/Api';
// import { AuthService } from '../../Services/Axios/Api';
import { useParams, useSearchParams } from 'react-router-dom';
import CTAPrimaryButton from '../../Components/CTAButton/CTAPrimaryButton/CTAPrimaryButton';
import { getCurrency } from '../../ComponentsMap';
import { t } from 'i18next';
import i18n from '../../Services/i18n/i18n';
import PayPalWrapper from '../../Components/Braintree/PayPalWrapper';
import ReCAPTCHA from "react-google-recaptcha";
import Visa from '../../Assets/Images/Visa.png';
import MasterCard from '../../Assets/Images/MasterCard.png';
import Noon from '../../Assets/Images/noon_payments.png';
import ApplePay from '../../Assets/Images/applepay.png';
import Meeza from '../../Assets/Images/Meeza.png';
import Fawry from '../../Assets/Images/fawry.webp';
import AhlyMomken from '../../Assets/Images/Momken.png';
import { faApplePay } from '@fortawesome/free-brands-svg-icons';
import { focusFirstInvalidField } from '../../utils/formValidation';

const DONATION_FORM_FIELD_ORDER = ['customAmount'];
// const DONATION_FORM_FIELD_ORDER = ['customAmount', 'firstName', 'lastName', 'email', 'phoneNumber'];
const RECURRING_FIELD_ORDER = [];
// const RECURRING_FIELD_ORDER = ['firstName', 'lastName', 'email', 'phoneNumber'];

const DonationForm = () => {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        amount: '10',
        customAmount: '',
        quantity: 1,
        isCustomQuantity: false,
        message: '',
        paymentMethod: '',
        isAnonymous: false
    });
    const [recaptchaToken, setRecaptchaToken] = useState(null);
    const { name } = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const id = searchParams.get('id');
    const [campaignData, setCampaignData] = useState(null);
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const shouldFocusErrors = useRef(false);

    useEffect(() => {
        const fetchCampaignData = async () => {
            try {
                const response = await CampaignService.getCampaignById(id);
                setCampaignData(response.result);
            } catch (error) {
                console.error('Error fetching campaign data:', error);
            }
        };
        fetchCampaignData();
    }, [id]);

    useEffect(() => {
        const fetchPaymentMethods = async () => {
            try {
                const response = await PaymentMethodService.getPublicPaymentMethods();
                const methods = response.result.reverse() || [];
                setPaymentMethods(methods);
                if (methods.length > 0) {
                    setFormData(prev => ({
                        ...prev,
                        paymentMethod: methods[0].provider
                    }));
                }
            } catch (error) {
                console.error('Error fetching payment methods:', error);
            }
        };
        fetchPaymentMethods();
    }, []);

    // Donor identity now comes from the authenticated account, not the form.
    // useEffect(() => {
    //     const fetchUserProfile = async () => {
    //         if (localStorage.getItem('isLoggedIn') === 'true') {
    //             try {
    //                 const response = await AuthService.getProfile();
    //                 if (response.isSuccess && response.result) {
    //                     setFormData(prev => ({
    //                         ...prev,
    //                         firstName: response.result.firstName || '',
    //                         lastName: response.result.lastName || '',
    //                         email: response.result.email || '',
    //                         phoneNumber: response.result.phoneNumber || ''
    //                     }));
    //                 }
    //             } catch (error) {
    //                 console.error('Error fetching user profile:', error);
    //             }
    //         }
    //     };
    //     fetchUserProfile();
    // }, []);

    useEffect(() => {
        if (paymentMethods.length === 1) {
            setFormData(prev => ({
                ...prev,
                paymentMethod: paymentMethods[0].provider
            }));
        }
    }, [paymentMethods]);

    useEffect(() => {
        if (!shouldFocusErrors.current || Object.keys(errors).length === 0) return;
        shouldFocusErrors.current = false;
        const fieldOrder = campaignData?.isRecurring ? RECURRING_FIELD_ORDER : DONATION_FORM_FIELD_ORDER;
        focusFirstInvalidField(errors, fieldOrder);
    }, [errors, campaignData?.isRecurring]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value
        });
    };
    const getPaymentMethodImage = (provider) => {
        // Normalize provider name for image lookup
        const normalizedProvider = provider?.toLowerCase();
        if (normalizedProvider?.includes('visa')) return Visa;
        if (normalizedProvider?.includes('mastercard') || normalizedProvider?.includes('master card')) return MasterCard;
        if (normalizedProvider?.includes('noon')) return Noon;
        if (normalizedProvider?.includes('meeza')) return Meeza;
        if (normalizedProvider?.includes('fawry')) return Fawry;
        if (normalizedProvider?.includes('ahly') || normalizedProvider?.includes('momken')) return AhlyMomken;
        return null;
    }

    const validateForm = () => {
        const errors = {};
        // if (!formData.firstName.trim()) errors.firstName = t('DonationForm.Validation.FirstNameRequired');
        // if (!formData.lastName.trim()) errors.lastName = t('DonationForm.Validation.LastNameRequired');
        // if (!formData.email.trim()) errors.email = t('DonationForm.Validation.EmailRequired');
        // else if (!/\S+@\S+\.\S+/.test(formData.email.trim())) errors.email = t('DonationForm.Validation.EmailInvalid');
        // if (!formData.phoneNumber.trim()) errors.phoneNumber = t('DonationForm.Validation.PhoneNumberRequired');
        if (!campaignData?.isRecurring) {
            if (formData.amount === 'custom' && (!formData.customAmount || formData.customAmount < 1)) {
                errors.customAmount = t('DonationForm.Validation.CustomAmountRequired');
            }
        }

        return errors;
    };

    const getDonationAmount = () => {
        if (campaignData?.isFixedPrice) {
            return campaignData.fixedPrice * formData.quantity;
        }
        return formData.amount === 'custom' ? formData.customAmount : formData.amount;
    };

    const buildDonationPayload = (paymentMethod) => ({
        campaignId: Number(id),
        amount: parseFloat(getDonationAmount()),
        currency: getCurrency().Appriviation,
        paymentMethod,
        message: formData.message,
        isAnonymous: formData.isAnonymous,
        quantity: campaignData?.isFixedPrice ? Number(formData.quantity) : 1
    });

    const handleSubmit = async (e) => {
        setErrors({});
        if (formData.paymentMethod !== 'PayPal') {
            e.preventDefault();
        }

        // if (!recaptchaToken) {
        //     alert("Please verify you're not a robot");
        //     return;
        // }

        const errors = validateForm();
        if (Object.keys(errors).length > 0) {
            shouldFocusErrors.current = true;
            setErrors(errors);
            return;
        }

        setIsLoading(true);

        try {
            if (!campaignData?.isRecurring) {
                const data = buildDonationPayload(formData.paymentMethod);
                // const data = {
                //     donorInfo: {
                //         "name": formData.firstName + " " + formData.lastName,
                //         "email": formData.email,
                //         "phoneNumber": formData.phoneNumber,
                //         "city": "",
                //         "country": "",
                //         "postalCode": "",
                //         "isAnonymous": formData.isAnonymous
                //     },
                //     "campaignId": id,
                //     "amount": campaignData?.isFixedPrice ? campaignData.fixedPrice * formData.quantity : (formData.amount === 'custom' ? formData.customAmount : formData.amount),
                //     "quantity": campaignData?.isFixedPrice ? formData.quantity : null,
                //     "currency": getCurrency().Appriviation,
                //     "paymentMethod": formData.paymentMethod,
                //     "message": formData.message,
                //     "isAnonymous": formData.isAnonymous
                // }
                const response = await DonationService.createDonation(data);
                if (formData.paymentMethod === 'PayPal') {
                    return response.result.transactionId;
                } else {
                    window.location.href = response.result;
                }
            } else {
                const data = buildDonationPayload('Noon');
                // const data = {
                //     "donor": {
                //         "name": formData.firstName + " " + formData.lastName,
                //         "email": formData.email,
                //         "phoneNumber": formData.phoneNumber,
                //         "city": "",
                //         "country": "",
                //         "postalCode": "",
                //         "isAnonymous": formData.isAnonymous
                //     },
                //     "campaignId": id,
                //     "paymentMethod": 'Noon',
                //     "amount": parseFloat(campaignData?.isFixedPrice ? campaignData.fixedPrice * formData.quantity : (formData.amount === 'custom' ? formData.customAmount : formData.amount))
                // }
                const response = await SubscriptionService.createSubscription(data);
                // console.log(response);
                console.log(response);
                if (formData.paymentMethod === 'PayPal') {
                    const parsedUrl = new URL(response.result.invoices[0].paymentUrl);
                    const transactionId = parsedUrl.searchParams.get("token");
                    return transactionId;
                } else {
                    window.location.href = response.result.invoices[0].paymentUrl;
                }
            }
        } catch (error) {
            console.error('Error creating donation:', error);
            setIsLoading(false);
        } finally {
            setIsLoading(false);
        }
    };



    const handleOnApprove = async (data) => {
        window.location.href = `/callback/PayPal?paymentId=${data.orderID}&payerId=${data.payerID}`;
    }

    return (
        <Container className="mt-5 mb-5 d-flex justify-content-center">
            <Col md={10}>
                <Card className="p-4 position-relative DonationFormCard">
                    {isLoading && (
                        <div
                            style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                zIndex: 100,
                                borderRadius: '0.375rem'
                            }}
                        >
                            <div className="text-center">
                                <Spinner animation="border" role="status" variant="primary">
                                    <span className="visually-hidden">Loading...</span>
                                </Spinner>
                                <p className="mt-2">Processing your donation...</p>
                            </div>
                        </div>
                    )}
                    {campaignData && (
                        <div
                            className="campaign-header"
                            style={{
                                background: campaignData?.mainImage
                                    ? `url('${campaignData.mainImage}') center center / cover no-repeat`
                                    : '#f8f9fa',
                                // color: campaignData?.mainImage ? 'white' : '#333',
                                padding: '20px',
                                width: '100%',
                                height: '200px',
                                borderRadius: '5px 5px 0px 0px'
                            }}

                        >
                            {/*                         
                            <h2 className="mb-2">{campaignData.name || 'Donation Form'}</h2>
                            <p>{campaignData.description || 'No description available'}</p> */}
                        </div>
                    )}
                    <Card.Body>
                        <Form onSubmit={handleSubmit}>
                            <Form.Group controlId="amount" className="mb-4">
                                {campaignData?.isFixedPrice ? (
                                            <>
                                                <Row className="mb-4 align-items-end">
                                                    <Col xs={6}>
                                                        <Form.Label className="fw-bold text-muted">{t('DonationForm.DonationAmount') || 'مبلغ التبرع'}</Form.Label>
                                                        <CTAPrimaryButton
                                                            className="amount-card filled w-100 m-0"
                                                            onClick={(e) => { e.preventDefault(); }}
                                                            text={`${getCurrency().Symbol} ${campaignData.fixedPrice}`}
                                                            style={{ height: '50px' }}
                                                        />
                                                    </Col>
                                                    <Col xs={6}>
                                                        <Form.Group controlId="fixedQuantity">
                                                            <Form.Label className="fw-bold text-muted">{i18n.exists('DonationForm.Quantity') ? t('DonationForm.Quantity') : 'الكمية'}</Form.Label>
                                                            <Form.Control
                                                                type="number"
                                                                value={formData.quantity}
                                                                onChange={(e) => setFormData({ ...formData, quantity: Math.max(1, parseInt(e.target.value) || 1) })}
                                                                min="1"
                                                                className="w-100 text-center fw-bold"
                                                                style={{ height: '50px', fontSize: '1.1rem', borderRadius: '8px' }}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <div className="text-center p-3 mb-4 rounded shadow-sm mt-3" style={{ backgroundColor: '#f8f9fa', border: '1px dashed #6c757d' }}>
                                                    <h5 className="mb-0 fw-bold" style={{ color: '#212529' }}>
                                                        {i18n.exists('DonationForm.TotalAmount') ? t('DonationForm.TotalAmount') : 'إجمالي المبلغ'}: {getCurrency().Symbol} {campaignData.fixedPrice * formData.quantity}
                                                    </h5>
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <Form.Label>{t('DonationForm.DonationAmount')}</Form.Label>
                                                <div className="d-flex flex-wrap justify-content-between">
                                                    {['10', '25', '50', '100', '250'].map((value) => (
                                                        <CTAPrimaryButton
                                                            key={value}
                                                            className={`amount-card ${formData.amount === value ? 'filled' : 'outlined'}`}
                                                            onClick={(e) => { e.preventDefault(); setFormData({ ...formData, amount: value, customAmount: '' }); }}
                                                            text={`${getCurrency().Symbol} ${value}`}
                                                        />
                                                    ))}
                                                    <CTAPrimaryButton
                                                        className={`amount-card ${formData.amount === 'custom' ? 'filled' : 'outlined'}`}
                                                        onClick={(e) => { e.preventDefault(); setFormData({ ...formData, amount: 'custom' }); }}
                                                        text={t('DonationForm.CustomAmount')}
                                                    />
                                                </div>
                                                {formData.amount === 'custom' && (
                                                    <>
                                                        <Form.Control
                                                            type="number"
                                                            id="customAmount"
                                                            placeholder={t('DonationForm.EnterCustomAmount')}
                                                            name="customAmount"
                                                            value={formData.customAmount}
                                                            onChange={handleChange}
                                                            min="10"
                                                            className="mt-3"
                                                            isInvalid={!!errors.customAmount}
                                                        />
                                                        {errors.customAmount && (
                                                            <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                                                                {errors.customAmount}
                                                            </Form.Control.Feedback>
                                                        )}
                                                    </>
                                                )}
                                            </>
                                        )}


                            </Form.Group>
                            {/* Donor fields are no longer collected on the form — identity comes from the logged-in account.
                            <Row className="mb-3">
                                <Col md={6}>
                                    <Form.Group controlId="firstName">
                                        <Form.Label>{t('DonationForm.FirstName')}</Form.Label>
                                        <InputGroup>
                                            <InputGroup.Text><FontAwesomeIcon icon={faUser} /></InputGroup.Text>
                                            <Form.Control
                                                type="text"
                                                placeholder={t('DonationForm.EnterYourFirstName')}
                                                name="firstName"
                                                value={formData.firstName}
                                                onChange={handleChange}
                                                required
                                                isInvalid={!!errors.firstName}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.firstName}
                                            </Form.Control.Feedback>
                                        </InputGroup>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group controlId="lastName">
                                        <Form.Label>{t('DonationForm.LastName')}</Form.Label>
                                        <InputGroup>
                                            <InputGroup.Text><FontAwesomeIcon icon={faUser} /></InputGroup.Text>
                                            <Form.Control
                                                type="text"
                                                placeholder={t('DonationForm.EnterYourLastName')}
                                                name="lastName"
                                                value={formData.lastName}
                                                onChange={handleChange}
                                                required
                                                isInvalid={!!errors.lastName}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.lastName}
                                            </Form.Control.Feedback>
                                        </InputGroup>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col md={6}>
                                    <Form.Group controlId="email">
                                        <Form.Label>{t('DonationForm.Email')}</Form.Label>
                                        <InputGroup>
                                            <InputGroup.Text><FontAwesomeIcon icon={faEnvelope} /></InputGroup.Text>
                                            <Form.Control
                                                type="email"
                                                placeholder={t('DonationForm.EnterYourEmail')}
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                                isInvalid={!!errors.email}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.email}
                                            </Form.Control.Feedback>
                                        </InputGroup>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group controlId="phoneNumber">
                                        <Form.Label>{t('DonationForm.PhoneNumber')}</Form.Label>
                                        <InputGroup>
                                            <InputGroup.Text><FontAwesomeIcon icon={faPhone} /></InputGroup.Text>
                                            <Form.Control
                                                dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                                                type="tel"
                                                placeholder={t('DonationForm.EnterYourPhoneNumber')}
                                                name="phoneNumber"
                                                value={formData.phoneNumber}
                                                onChange={handleChange}
                                                required
                                                isInvalid={!!errors.phoneNumber}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.phoneNumber}
                                            </Form.Control.Feedback>
                                        </InputGroup>
                                    </Form.Group>
                                </Col>
                            </Row>
                            */}

                            <Form.Group controlId="message" className="mb-3">
                                <Form.Label>{t('DonationForm.Message')}</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    placeholder={t('DonationForm.EnterYourMessage')}
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                />
                            </Form.Group>

                            {campaignData?.isRecurring ? (
                                <div className="noon-only-notice mb-4">
                                    <span>{t('DonationForm.NoonOnlyNotice') || 'الدفع الشهري يتم عبر بوابة Noon فقط'}</span>
                                    <img src={Noon} width={50} alt="Noon Payments" className="m-2" />
                                </div>
                            ) : paymentMethods.length > 1 ? (
                                <Form.Group controlId="paymentMethod" className="mb-3">
                                    <Form.Label>
                                        {t('DonationForm.PaymentMethod')}
                                        <img src={getPaymentMethodImage("Meeza")} width={50} alt="Payment Method" className='m-2' />
                                        <img src={getPaymentMethodImage("Visa")} width={50} alt="Payment Method" className='m-2' />
                                        <img src={getPaymentMethodImage("MasterCard")} width={50} alt="Payment Method" className='m-2' />
                                    </Form.Label>
                                    <p>{t('DonationForm.Disclaimer')}</p>
                                    <div>
                                        {paymentMethods.map((method) => {
                                                const methodName = method.name;
                                                const methodProvider = method.provider;
                                                return (
                                                    <>
                                                        {i18n.language === 'ar' ? (
                                                            <div key={methodProvider} className='d-flex align-items-center'>
                                                                <input type="radio" className='m-2 form-check-input' name="paymentMethod" id={methodProvider} value={methodProvider} checked={formData.paymentMethod === methodProvider} onChange={handleChange} />
                                                                <label htmlFor={methodProvider}>{methodProvider === 'Noon' ? 'Noon Payments' : methodName} <img src={getPaymentMethodImage(methodProvider)} width={50} alt={methodName} className='m-2' /></label>
                                                                {methodProvider === 'Noon' && <img src={ApplePay} width={50} alt="Apple Pay" className='m-2' />}

                                                            </div>
                                                        ) : (
                                                            <div key={methodProvider} className='d-flex align-items-center'>
                                                                <input type="radio" className='m-2 form-check-input' name="paymentMethod" id={methodProvider} value={methodProvider} checked={formData.paymentMethod === methodProvider} onChange={handleChange} />
                                                                <label htmlFor={methodProvider}>{methodProvider === 'Noon' ? 'Noon Payments' : methodName}
                                                                    <img src={getPaymentMethodImage(methodProvider)} width={50} alt={methodName} className='m-2' />
                                                                    {methodProvider === 'Noon' && <img src={ApplePay} width={50} alt="Apple Pay" className='m-2' />}
                                                                </label>
                                                            </div>
                                                        )}
                                                    </>
                                                );
                                            })}
                                    </div>
                                </Form.Group>
                            ) : null}
                            {/* <Form.Group controlId="isAnonymous" className="mb-3 d-flex justify-content-center">
                                <input type="checkbox" className='me-2 form-check-input' nam e="isAnonymous" id='isAnonymous' checked={formData.isAnonymous} onChange={(e) => setFormData({ ...formData, isAnonymous: e.target.checked })} />
                                <label className='me-2' htmlFor='isAnonymous'>{t('DonationForm.DonateAnonymously')}
                                </label>
                            </Form.Group> */}
                            <div className="secure-payment-disclaimer">
                                <div className="secure-shield">
                                    <svg width="60" height="70" viewBox="0 0 60 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M30 0L5 11.25V33.75C5 50.85 15.65 66.75 30 70C44.35 66.75 55 50.85 55 33.75V11.25L30 0Z" fill="#00C09A"/>
                                        <path d="M24.75 46.25L14.75 36.25L18.25 32.75L24.75 39.25L41.75 22.25L45.25 25.75L24.75 46.25Z" fill="white"/>
                                    </svg>
                                </div>
                                <div className="secure-text">
                                    {t('DonationForm.SecurePaymentDisclaimer') || 'كل بياناتك ومعاملاتك آمنة'}
                                </div>
                                <div className="secure-logos">
                                    <div className="logo-item mcafee">
                                        <svg viewBox="0 0 140 40" width="105" height="30" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M5 5l12-4 12 4v16c0 7-5 13-12 15-7-2-12-8-12-15V5z" fill="#C01818" />
                                            <path d="M17 9l-7 2.3v10.5c0 4.5 3 8.3 7 9.5 4-1.2 7-5 7-9.5V11.3L17 9z" fill="#E31B23" />
                                            <path d="M19 12.5v12l-2-1.5-2 1.5v-12l2 1.5 2-1.5zM15 12.5v12l-2-1.5-2 1.5v-12l2 1.5 2-1.5z" fill="#FFF" />
                                            <text x="36" y="27" fontFamily="Arial, Helvetica, sans-serif" fontWeight="bold" fontSize="19" fill="#1e1e1e">McAfee</text>
                                            <circle cx="106" cy="16" r="2.5" fill="none" stroke="#1e1e1e" strokeWidth="0.5" />
                                            <text x="104.7" y="18" fontFamily="Arial" fontSize="4.5" fill="#1e1e1e">R</text>
                                        </svg>
                                    </div>
                                    <div className="logo-item payfort">
                                        <svg viewBox="0 0 150 40" width="112" height="30" xmlns="http://www.w3.org/2000/svg">
                                            <text x="10" y="14" fontFamily="Arial, Helvetica, sans-serif" fontSize="9" fill="#666666" fontWeight="bold">Verified by</text>
                                            <text x="10" y="32" fontFamily="Arial, Helvetica, sans-serif" fontWeight="900" fontSize="17" fill="#003366">PAY</text>
                                            <text x="44" y="32" fontFamily="Arial, Helvetica, sans-serif" fontWeight="500" fontSize="17" fill="#00B050">FORT</text>
                                            <path d="M96 24l-4.5-4.5-1.5 1.5 6 6 10-10-1.5-1.5z" fill="#00B050" />
                                            <path d="M99 12h-12v14l12 3 12-3V12z" fill="none" stroke="#003366" strokeWidth="1.5" />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <div className="w-100">
                                <div className="d-flex justify-content-center mb-3">
                                    <ReCAPTCHA
                                        sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY || "6LeUyq4sAAAAAED6EEYKWhqPNMVhimC1mSNqRN9t"}
                                        onChange={(value) => setRecaptchaToken(value)}
                                    />
                                </div>
                                {formData.paymentMethod === 'PayPal' ? (
                                    <PayPalWrapper handleCreateOrder={handleSubmit} handleOnApprove={(data) => handleOnApprove(data)} />
                                ) : (
                                    <CTAPrimaryButton
                                        className="w-100"
                                        text={t('DonateNow')}
                                        onClick={(e) => handleSubmit(e)}
                                    />
                                )}
                            </div>

                        </Form>
                    </Card.Body>
                </Card>
            </Col>
        </Container>
    );
};

export default DonationForm;